import React, {Component} from 'react';
import Axios from 'axios';
// import { Tooltip as ReactTooltip } from 'react-tooltip';
// import Modal from 'react-modal';

import {requestAccessToWorkspace} from '../Services/ProfileRoutes';
import {formatAndValidatePhone} from '../Functions/FormatAndValidatePhone';
import {formatAndValidateEmail} from '../Functions/FormatAndValidateEmail';
import {validateBirthdate} from '../Functions/ValidateBirthdate';
import {validateZipCode} from '../Functions/ValidateZipCode';

const profileIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-dark.png';

class RenderSignUpFields extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }

      this.optionClicked2 = this.optionClicked2.bind(this)
      this.renderSignUpFields = this.renderSignUpFields.bind(this)
      this.renderSignUpField = this.renderSignUpField.bind(this)
      this.submitSignUpFields = this.submitSignUpFields.bind(this)
      this.submitRequest = this.submitRequest.bind(this)
      this.openSignUpFieldsModal = this.openSignUpFieldsModal.bind(this)
      this.formChangeHandler = this.formChangeHandler.bind(this)

    }

    componentDidMount() {
      //see if user is logged in

      this.retrieveData()

    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in renderSignUpFields', this.props, prevProps)

      // if (this.props.activeOrg !== prevProps.activeOrg) {
      //   this.retrieveData()
      // }

    }

    retrieveData() {
      console.log('retrieveData called in renderSignUpFields')

      const orgSelected = this.props.orgSelected
      this.setState({ orgSelected })

      // const opportunity = this.props.opportunityId
      const accountCode = this.props.accountCode

      let email = localStorage.getItem('email');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      let username = localStorage.getItem('username');
      let activeOrg = localStorage.getItem('activeOrg');
      let orgFocus = localStorage.getItem('orgFocus');
      let remoteAuth = localStorage.getItem('remoteAuth');
      let myOrgs = localStorage.getItem('myOrgs');
      if (myOrgs) {
        myOrgs = JSON.parse(myOrgs)
      }

      this.setState({ emailId: email, cuFirstName, cuLastName, username, activeOrg, orgFocus, remoteAuth })

      const fetchDetailsURL = '/api/users/profile/details/' + email
      Axios.get(fetchDetailsURL)
      .then((response) => {
        if (response.data) {

          let myOrgs = response.data.user.myOrgs
          const joinRequests = response.data.user.joinRequests

          const workAuthorization = response.data.user.workAuthorization
          const zipcode = response.data.user.zipcode
          const dateOfBirth = response.data.user.dateOfBirth
          const gender = response.data.user.gender
          const race = response.data.user.race
          const races = response.data.user.races
          const selfDescribedRace = response.data.user.selfDescribedRace
          const address = response.data.user.address
          const city = response.data.user.city
          const state = response.data.user.state
          const phoneNumber = response.data.user.phoneNumber
          const alternativePhoneNumber = response.data.user.alternativePhoneNumber
          const alternativeEmail = response.data.user.alternativeEmail
          const numberOfMembers = response.data.user.numberOfMembers
          const householdIncome = response.data.user.householdIncome
          const fosterYouth = response.data.user.fosterYouth
          const homeless = response.data.user.homeless
          const incarcerated = response.data.user.incarcerated
          const adversityList = response.data.user.adversityList

          const pictureURL = response.data.user.pictureURL
          const education = response.data.user.education
          const educationStatus = response.data.user.educationStatus

          const referrerName = response.data.user.referrerName
          const referrerEmail = response.data.user.referrerEmail
          const referrerOrg = response.data.user.referrerOrg

          this.setState({ myOrgs, joinRequests, workAuthorization, zipcode, dateOfBirth, gender, race, races, selfDescribedRace,
            address, city, state, phoneNumber, alternativePhoneNumber, alternativeEmail, numberOfMembers,
            householdIncome, fosterYouth, homeless, incarcerated, adversityList, pictureURL, education, educationStatus,
            referrerName, referrerEmail, referrerOrg
          })

        }
      }).catch((error) => {
          console.log('Profile pic fetch did not work', error);
      });
    }

    renderSignUpFields() {
      console.log('renderSignUpFields called')

      let rows = []
      let spaceCounter = 0
      for (let i = 1; i <= this.state.orgSelected.signUpFieldsRequired.length; i++) {
        const value = this.state.orgSelected.signUpFieldsRequired[i - 1]
        const index = i - 1

        let showQuestion = true
        if (value.questionType !== 'Multiple Answer') {
          // console.log('in it: ', value.name, spaceCounter)
          if (value.rule) {
            if (value.rule.name === 'races' && this.state.races && this.state.races.includes(value.rule.value)) {
              spaceCounter = spaceCounter + 1
            } else {
              showQuestion = false
            }
          } else {
            spaceCounter = spaceCounter + 1
          }
        }

        rows.push(
          <div key={'renderSignUpFields' + index}>
            {(showQuestion) && (
              <div>
                <div className={(value.questionType === 'Multiple Answer') ? "full-width" : "container-left"}>
                  {this.renderSignUpField(value, index)}
                </div>
                {(value.questionType === 'Multiple Answer' || spaceCounter % 2 === 0) && (
                  <div>
                    <div className="clear" />
                    <div className="spacer" />
                  </div>
                )}
                {(this.state.orgSelected.signUpFieldsRequired[i] && this.state.orgSelected.signUpFieldsRequired[i].questionType === 'Multiple Answer') && (
                  <div>
                    <div className="clear" />
                    <div className="spacer" />
                  </div>
                )}
              </div>
            )}
          </div>
        )
      }

      return rows
    }

    renderSignUpField(value, index) {
      console.log('renderSignUpField called')

      return (
        <div key="signUpField">
          <label className="profile-label">{value.name}{(value.required) && <label className="error-color bold-text">*</label>}</label>
          {(value.questionType === 'Date') && (
            <input type="date" className="date-picker white-background" name={value.shorthand} value={this.state[value.shorthand]} onChange={this.formChangeHandler}></input>
          )}
          {(value.questionType === 'Short Answer') && (
            <input type="text" className="text-field" placeholder={(value.placeholder) ? value.placeholder : "Your answer..."} name={value.shorthand} value={this.state[value.shorthand]} onChange={this.formChangeHandler}></input>
          )}
          {(value.questionType === 'Multiple Choice') && (
            <select name={value.shorthand} className="dropdown" value={this.state[value.shorthand]} onChange={this.formChangeHandler}>
                {[''].concat(value.answerChoices).map(value => <option key={value} value={value}>{value}</option>)}
            </select>
          )}
          {(value.questionType === 'Multiple Answer') && (
            <div>
              {value.answerChoices.map((value2, optionIndex) =>
                <div key={value2 + optionIndex}>
                  <div className="top-margin-5 right-padding">
                    {(this.state[value.shorthand] && this.state[value.shorthand].includes(value2)) ? (
                      <button className="background-button tag-container-6 float-left cta-background-color" onClick={() => this.optionClicked2(index, optionIndex, value, value2)}>
                        <div>
                          <div className="float-left left-text">
                            <p className="description-text-2 white-text">{value2}</p>
                          </div>
                        </div>
                      </button>
                    ) : (
                      <button className="background-button tag-container-6 float-left" onClick={() => this.optionClicked2(index, optionIndex, value, value2)}>
                        <div>
                          <div className="float-left left-text">
                            <p className="description-text-2">{value2}</p>
                          </div>
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {(value.shorthand === this.state.errorField) && (
            <div className="row-10">
              <p className="error-color description-text-2">{this.state.fieldErrorMessage}</p>
            </div>
          )}
        </div>
      )
    }

    optionClicked2(index, optionIndex, value, value2) {
      console.log('optionClicked2 called', index, optionIndex, value, value2)

      let items = this.state[value.shorthand]
      if (items) {
        if (items.includes(value2)) {
          const index = items.indexOf(value2)
          items.splice(index, 1)
        } else {
          items.push(value2)
        }

      } else {
        items = [value2]
      }

      this.setState({ [value.shorthand]: items })

    }

    submitSignUpFields() {
      console.log('submitSignUpFields called')

      this.setState({ errorMessage: null, successMessage: null, isSaving: true })

      if (this.state.orgSelected.signUpFieldsRequired && this.state.orgSelected.signUpFieldsRequired.length > 0) {
        for (let i = 1; i <= this.state.orgSelected.signUpFieldsRequired.length; i++) {
          console.log('l1')
          const item = this.state.orgSelected.signUpFieldsRequired[i - 1]

          if (item.required) {
            if (item.questionType === 'Multiple Answer' && (!this.state[item.shorthand] || this.state[item.shorthand].length === 0)) {
              return this.setState({ errorMessage: 'Please add answer(s) for ' + this.state.orgSelected.signUpFieldsRequired[i - 1].name, isSaving: false })
            } else if (!item.shorthand.includes("|") && (!this.state[item.shorthand] || !this.state[item.shorthand] === '')) {
              return this.setState({ errorMessage: 'Please add an answer for ' + item.name, isSaving: false })
            } else if (item.shorthand.includes("|") && (!this.state[item.shorthand.split("|")[0]] || this.state[item.shorthand.split("|")[0]].length === 0)) {
              return this.setState({ errorMessage: 'Please add your current / latest school name', isSaving: false })
              console.log('what is missing', item.shorthand, this.state[item.shorthand.split("|")[0]])
            } else if (item.shorthand.includes("|")) {
              console.log('l3')
              if (!this.state[item.shorthand.split("|")[0]] || this.state[item.shorthand.split("|")[0]].length === 0) {
                return this.setState({ errorMessage: 'Please add answer(s) for the education fields - degree type, year, major/pathway', isSaving: false })
              } else if (!this.state[item.shorthand.split("|")[0]][0][item.shorthand.split("|")[1]]) {
                return this.setState({ errorMessage: 'Please add answer(s) for each of the education fields', isSaving: false })
              }
              console.log('l4')
            }
          }
        }
      }

      // validate phone number
      if (this.state.phoneNumber && !formatAndValidatePhone(this.state.phoneNumber)) {
        return this.setState({ errorMessage: 'Please add a valid phone number in the format 555-555-5555.', isSaving: false })
      }
      // validate alternative email
      if (this.state.alternativeEmail && !formatAndValidateEmail(this.state.alternativeEmail)) {
        return this.setState({ errorMessage: 'Please add a valid alternative email.', isSaving: false })
      }
      // validate alternative phone number
      if (this.state.alternativePhoneNumber && !formatAndValidatePhone(this.state.alternativePhoneNumber)) {
        return this.setState({ errorMessage: 'Please add a valid alternative phone number in the format 555-555-5555.', isSaving: false })
      }
      // validate date of birth
      if (this.state.dateOfBirth && !validateBirthdate(this.state.dateOfBirth)) {
        return this.setState({ errorMessage: "Oops! To continue, your date of birth must show that you're between 12 and 100 years old.", isSaving: false })
      }
      // validate zip code
      if (this.state.zipcode && !validateZipCode(this.state.zipcode)) {
        return this.setState({ errorMessage: 'Please add a valid 5-digit zip code.', isSaving: false })
      }

      const dateOfBirth = this.state.dateOfBirth
      const gender = this.state.gender
      const race = this.state.race
      const races = this.state.races
      const selfDescribedRace = this.state.selfDescribedRace
      const address = this.state.address
      const city = this.state.city
      const state = this.state.state
      const zipcode = this.state.zipcode
      const phoneNumber = this.state.phoneNumber
      const alternativePhoneNumber = this.state.alternativePhoneNumber
      const alternativeEmail = this.state.alternativeEmail
      const numberOfMembers = this.state.numberOfMembers
      const householdIncome = this.state.householdIncome
      const fosterYouth = this.state.fosterYouth
      const homeless = this.state.homeless
      const incarcerated = this.state.incarcerated
      const workAuthorization = this.state.workAuthorization
      const adversityList = this.state.adversityList
      const educationStatus = this.state.educationStatus

      let education = this.state.education
      // if (this.state.education && this.state.education[0]) {
      //   education[0]['name'] = this.state.education.name
      //   education[0]['endDate'] = this.state.education.endDate
      //   education[0]['major'] = this.state.education.major
      // }
      const referrerName = this.state.referrerName
      const referrerEmail = this.state.referrerEmail
      const referrerOrg = this.state.referrerOrg

      const signUpFields = {
        dateOfBirth, gender, race, races, selfDescribedRace, address, city, state, zipcode,
        phoneNumber, alternativePhoneNumber,
        alternativeEmail, numberOfMembers, householdIncome, workAuthorization,
        fosterYouth, homeless, incarcerated, adversityList, education, educationStatus,
        referrerName, referrerEmail, referrerOrg
      }

      console.log('request submitted', education)
      this.submitRequest(null, this.state.orgSelected, signUpFields, false)
    }

    async submitRequest(e, value, passedSignUpFields, fromButton) {
      console.log('submitRequest called')

      let cta = 'Join Workspace'
      if (!value.isOpen) {
        cta = 'Request Access'
      }

      const showMyCommunities = true

      if (value.isOpen) {
        // console.log('82', value.signUpFields)
        if (value.signUpFieldsRequired && value.signUpFieldsRequired.length > 0) {
          if (passedSignUpFields) {
            const returnedValue = await requestAccessToWorkspace(this.state.emailId, value.orgCode, value.orgName, cta, value.contactFirstName, value.contactLastName, value.contactEmail, passedSignUpFields)
            console.log('returnedValue: ', returnedValue)
            if (returnedValue.success) {
              let myOrgs = this.state.myOrgs
              if (returnedValue.success) {
                if (myOrgs) {
                  myOrgs.push(value.orgCode)
                } else {
                  myOrgs = [value.orgCode]
                }
              }

              localStorage.setItem('activeOrg', value.orgCode)
              localStorage.setItem('myOrgs', JSON.stringify(myOrgs))
              localStorage.setItem('orgName', value.orgName)
              localStorage.setItem('orgLogo', value.webLogoURIColor)

              this.setState({ isSaving: false })
              // this.setState({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, myOrgs, modalIsOpen: false, showSignUpFields: false, showMyCommunities })
              // this.retrieveData()

              this.props.passData({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, myOrgs, value, modalIsOpen: false, showSignUpFields: false, showMyCommunities })

            } else {

              let errorMessage = ''
              if (returnedValue) {
                errorMessage = returnedValue.errorMessage
              }

              this.setState({ errorMessage: 'There was an error: ' + errorMessage, isSaving: false })
            }
          } else {
            this.setState({ isSaving: false })
            // this.setState({ modalIsOpen: true, orgSelected: value, showSignUpFields: true, showOrgDetails: false })

            this.openSignUpFieldsModal(value)
          }

        } else {
          const returnedValue = await requestAccessToWorkspace(this.state.emailId, value.orgCode, value.orgName, cta, value.contactFirstName, value.contactLastName, value.contactEmail, null)
          console.log('returnedValue: ', returnedValue)
          if (returnedValue.success) {
            let myOrgs = this.state.myOrgs
            if (returnedValue.success) {
              if (myOrgs) {
                myOrgs.push(value.orgCode)
              } else {
                myOrgs = [value.orgCode]
              }
            }

            localStorage.setItem('activeOrg', value.orgCode)
            localStorage.setItem('myOrgs', JSON.stringify(myOrgs))
            localStorage.setItem('orgName', value.orgName)
            localStorage.setItem('orgLogo', value.webLogoURIColor)

            this.props.passData({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, myOrgs, value, showMyCommunities, isSaving: false })
            // this.setState({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, myOrgs, showMyCommunities, isSaving: false })
            // this.retrieveData()

          } else {
            let errorMessage = ''
            if (returnedValue) {
              errorMessage = returnedValue.errorMessage
            }
            this.setState({ errorMessage: 'There was an error: ' + errorMessage, isSaving: false })
          }
        }

      } else {
        console.log('request access')

        if (value.signUpFields && value.signUpFields.length > 0) {
          if (passedSignUpFields) {
            const returnedValue = await requestAccessToWorkspace(this.state.emailId, value.orgCode, value.orgName, cta, value.contactFirstName, value.contactLastName, value.contactEmail, passedSignUpFields)
            // console.log('returnedValue: ', returnedValue)
            if (returnedValue.success) {
              let joinRequests = this.state.joinRequests
              if (returnedValue.success) {
                if (joinRequests) {
                  joinRequests.push(value.orgCode)
                } else {
                  joinRequests = [value.orgCode]
                }
              }

              this.setState({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, joinRequests, modalIsOpen: false, showSignUpFields: false, showMyCommunities, isSaving: false })
            } else {
              let errorMessage = ''
              if (returnedValue) {
                errorMessage = returnedValue.errorMessage
              }
              this.setState({ errorMessage: 'There was an error: ' + errorMessage, isSaving: false })
            }
          } else {
            this.setState({ modalIsOpen: true, orgSelected: value, showSignUpFields: false, isSaving: false })
          }

        } else {

          const returnedValue = await requestAccessToWorkspace(this.state.emailId, value.orgCode, value.orgName, cta, value.contactFirstName, value.contactLastName, value.contactEmail, null, null, null, null)
          console.log('returnedValue: ', returnedValue)
          if (returnedValue.success) {
            let joinRequests = this.state.joinRequests
            if (returnedValue.success) {
              if (joinRequests) {
                joinRequests.push(value.orgCode)
              } else {
                joinRequests = [value.orgCode]
              }
            }

            this.setState({ errorMessage: returnedValue.errorMessage, successMessage: returnedValue.successMessage, joinRequests, isSaving: false })

          } else {
            let errorMessage = ''
            if (returnedValue) {
              errorMessage = returnedValue.errorMessage
            }
            this.setState({ errorMessage: 'There was an error: ' + errorMessage, isSaving: false })
          }
        }
      }
    }

    openSignUpFieldsModal(orgSelected) {
      console.log('openSignUpFieldsModal called')

      Axios.get('/api/workoptions')
      .then((response) => {
        console.log('Work options query tried', response.data);

        if (response.data.success) {
          console.log('Work options query succeeded')

          const degreeOptions = response.data.workOptions[0].degreeOptions.slice(1,response.data.workOptions[0].degreeOptions.lengh)

          const educationStatusOptions = degreeOptions.concat(['Not currently enrolled in school'])

          let educationDateOptions = []

          const currentMonth = new Date().getMonth()
          const currentYear = new Date().getFullYear()

          let numberOfYears = 25
          let educationBump = 5
          let month = ''
          let year = currentYear - numberOfYears

          // console.log('show me current stuff', currentMonth, currentYear)
          for (let i = 1; i <= ((numberOfYears + educationBump) * 12); i++) {
            // console.log('show me stuff', i, (i + currentMonth + 1) % 12)
            if ((i + currentMonth + 1) % 12 === 2) {
              month = 'January'
            } else if ((i + currentMonth + 1) % 12 === 3) {
              month = 'February'
            } else if ((i + currentMonth + 1) % 12 === 4) {
              month = 'March'
            } else if ((i + currentMonth + 1) % 12 === 5) {
              month = 'April'
            } else if ((i + currentMonth + 1) % 12 === 6) {
              month = 'May'
            } else if ((i + currentMonth + 1) % 12 === 7) {
              month = 'June'
            } else if ((i + currentMonth + 1) % 12 === 8) {
              month = 'July'
            } else if ((i + currentMonth + 1) % 12 === 9) {
              month = 'August'
            } else if ((i + currentMonth + 1) % 12 === 10) {
              month = 'September'
            } else if ((i + currentMonth + 1) % 12 === 11) {
              month = 'October'
            } else if ((i + currentMonth + 1) % 12 === 0) {
              month = 'November'
            } else if ((i + currentMonth + 1) % 12 === 1) {
              month = 'December'
            }

            if (month === 'January') {
              year = year + 1
            }

            // dateOptions.push({ value: month + ' ' + year})
            if (i <= (numberOfYears * 12)) {
              // dateOptions.push({ value: month + ' ' + year})
            }
            educationDateOptions.push(month + ' ' + year)

          }

          const raceOptions = response.data.workOptions[0].raceOptions
          const genderOptions = response.data.workOptions[0].genderOptions

          const householdIncomeOptions = response.data.workOptions[0].lowIncomeOptions
          const adversityListOptions = response.data.workOptions[0].adversityListOptions
          const numberOfMembersOptions = response.data.workOptions[0].numberOfMembersOptions
          const workAuthorizationOptions = response.data.workOptions[0].workAuthorizationOptions
          // console.log('show educationDateOptions: ', educationDateOptions)
          const workOptions = {
            raceOptions, genderOptions, degreeOptions, householdIncomeOptions, adversityListOptions,
            numberOfMembersOptions, workAuthorizationOptions,
            educationStatusOptions, educationDateOptions
          }

          if (orgSelected.signUpFieldsRequired && orgSelected.signUpFieldsRequired.length > 0) {
            let signUpFieldsRequired = orgSelected.signUpFieldsRequired
            for (let i = 1; i <= signUpFieldsRequired.length; i++) {
              if (signUpFieldsRequired[i - 1].answerChoices && signUpFieldsRequired[i - 1].answerChoices.length === 1) {
                signUpFieldsRequired[i - 1].answerChoices = workOptions[signUpFieldsRequired[i - 1].answerChoices[0]]
              }
            }
          }

          this.setState({ modalIsOpen: true, orgSelected, showSignUpFields: true, showOrgDetails: false })

        } else {
          console.log('no workOptions found')

        }
      }).catch((error) => {
          console.log('query for work options did not work', error);
      })
    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler called ', event.target.name, event.target.value)

      if (event.target.name.includes('education|')) {
        const name = event.target.name.split("|")[1]

        let education = this.state.education
        if (education && education[0]) {
          education[0][name] = event.target.value
        } else {
          education = [{}]
          education[0][name] = event.target.value
        }

        this.setState({ education })

      } else {
        this.setState({ [event.target.name]: event.target.value, errorField: null, fieldErrorMessage: null })

        if (event.target.name === 'phoneNumber' || event.target.name === 'alternativePhoneNumber') {
          const formatted = formatAndValidatePhone(event.target.value);

          if (formatted) {
            this.setState({ [event.target.name]: formatted })
          } else {
            this.setState({ errorField: event.target.name, fieldErrorMessage: 'Invalid U.S. phone number' })
          }
        } else if (event.target.name === 'email' || event.target.name === 'alternativeEmail') {
          const formatted = formatAndValidateEmail(event.target.value);

          if (formatted) {
            this.setState({ [event.target.name]: formatted })
          } else {
            this.setState({ errorField: event.target.name, fieldErrorMessage: 'Invalid email' })
          }
        } else if (event.target.name === 'dateOfBirth') {

          const isValid = validateBirthdate(event.target.value);

          if (!isValid) {
            this.setState({ errorField: this.state.customAssessment.questions[index - this.state.survey.questions.length].shortname, fieldErrorMessage: "Oops! To continue, your date of birth must show that you're between 12 and 100 years old." })
          }

        } else if (event.target.name === 'zipCode') {

          const isValid = validateZipCode(event.target.value);

          if (!isValid) {
            this.setState({ errorField: this.state.customAssessment.questions[index - this.state.survey.questions.length].shortname, fieldErrorMessage: 'Invalid zip code' })
          }
        }
      }
    }

    render() {

      return (
        <div>
          {(this.state.orgSelected) && (
            <div>
              <p className="heading-text-2">Sign Up Fields for {this.state.orgSelected.orgName}</p>

              <p className="row-10">{this.state.orgSelected.orgName} requires the following fields before joining their workspace</p>

              {(this.props.opportunityId) && (
                <p className="row-10">After you sign up to the {this.state.orgSelected.orgName} workspace, you will be able to access this opportunity.</p>
              )}
              <div className="spacer" />

              {this.renderSignUpFields()}

              <div className="clear" />

              {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="row-5 top-margin-5 description-text-2 error-color">{this.state.errorMessage}</p>}
              {(this.state.successMessage && this.state.successMessage !== '') && <p className="row-5 top-margin-5 description-text-2 cta-color">{this.state.successMessage}</p>}

              <div className="top-padding-20">
                <button className="btn btn-primary" disabled={this.state.isSaving} onClick={() => this.submitSignUpFields()}>Submit</button>
              </div>
            </div>
          )}
        </div>
      )
    }
}

export default RenderSignUpFields;
